import { Injectable } from '@angular/core';
import { LoggerService } from '../shared/logger.service';

@Injectable({
  providedIn: 'root'
})
export class MySingletonService {

  private _refreshingToken: boolean = false;

  constructor(
    private logger: LoggerService
  ) {
    logger.debug(`construction...`);
   }

   get refreshingToken():boolean {
    return this._refreshingToken;
   }
   set refreshingToken(val:boolean) {
    this._refreshingToken = val;
   }
   get isRefreshing():boolean {
    return this._refreshingToken === true;
   }
}
